import { Injectable } from '@angular/core';
import { ApiClientService } from 'projects/dnest-core-angular/src/public-api';
import { UserPreferences } from 'src/app/models/user-preferences';

@Injectable({
  providedIn: 'root'
})
export class UserpreferencesApiClientService extends ApiClientService<UserPreferences> {
  endpoint = 'userpreferences';
}
